let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19;
import { match } from 'ts-pattern';
import styled, { css } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
export const AvatarImg = styled.img(_t || (_t = _`
    width: 100%;
    height: 100%;

    border-radius: 9999px;
`));
const flexCenter = css(_t2 || (_t2 = _`
    display: flex;
    align-items: center;
    justify-content: center;
`));
export const Main = styled.div(_t3 || (_t3 = _`
    ${0}

    width: 100%;
    height: 100%;
    overflow: hidden;
`), flexCenter);
const logoStatusSizeStyle = css(_t4 || (_t4 = _`
    width: ${0};
    height: ${0};

    border-radius: ${0};
`), ({
  size
}) => size, ({
  size
}) => size, ({
  size
}) => size);
const statusCommonStyle = css(_t5 || (_t5 = _`
    ${0}

    position: absolute;
    right: 0%;
    bottom: 0%;

    box-sizing: content-box;

    border: 2px solid ${0};

    transform: translate(33%, 33%);
`), flexCenter, colors.neutralWhite);
const getStatusIndicatorStyles = status => {
  switch (status) {
    case true:
      return css(_t6 || (_t6 = _`
                background-color: ${0};
            `), colors.successBase);
    case false:
      return css(_t7 || (_t7 = _`
                background-color: ${0};
            `), colors.neutralBgHover);
    case undefined:
    default:
      return css(_t8 || (_t8 = _``));
  }
};
export const Status = styled.div(_t9 || (_t9 = _`
    ${0}
    ${0}
    ${0}
`), statusCommonStyle, logoStatusSizeStyle, ({
  isOnline
}) => getStatusIndicatorStyles(isOnline));
export const Logo = styled.div(_t10 || (_t10 = _`
    ${0}
    ${0}

    background-color: ${0};
`), statusCommonStyle, logoStatusSizeStyle, colors.neutralWhite);
export const Avatar = styled.div(_t11 || (_t11 = _`
    position: relative;

    flex-shrink: 0;

    background-color: ${0};

    border-radius: 50%;

    ${0}

    &:hover {
        background-color: ${0};
    }

    &:focus {
        z-index: 99;

        background-color: ${0};
        box-shadow: 0px 0px 0px 4px rgba(59, 145, 241, 0.45);
    }
`), colors.neutralOffwhite, ({
  size
}) => match(size).with('sm', () => css(_t12 || (_t12 = _`
                    width: 24px;
                    height: 24px;
                `))).with('md', () => css(_t13 || (_t13 = _`
                    width: 32px;
                    height: 32px;
                `))).with('lg', () => css(_t14 || (_t14 = _`
                    width: 40px;
                    height: 40px;
                `))).exhaustive(), colors.neutralBgHover, colors.neutralOffwhite);
export const Root = styled.div(_t15 || (_t15 = _`
    display: flex;
    align-items: center;
`));
export const Label = styled.label(_t16 || (_t16 = _`
    display: flex;
    flex-direction: column;

    ${0}
`), ({
  size
}) => match(size).with('sm', () => css(_t17 || (_t17 = _`
                    margin-left: 8px;
                `))).with('md', () => css(_t18 || (_t18 = _`
                    margin-left: 16px;
                `))).with('lg', () => css(_t19 || (_t19 = _`
                    margin-left: 16px;
                `))).exhaustive());